import { render, staticRenderFns } from "./WikiPagePartialSelectModal.vue?vue&type=template&id=74824a88"
import script from "./WikiPagePartialSelectModal.vue?vue&type=script&lang=ts"
export * from "./WikiPagePartialSelectModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports